/*
  Project: Smith And Jones
  Author: Via Studios
 */

import InitFrontpage from './modules/frontpage';
// import InitCursor from './modules/cursor';
import InitReel from './modules/reel';
import InitClips from './modules/clips';
import InitAnchorClicks from './modules/anchorscroll';
import InitPageAnimate from './modules/pageanimate';

document.addEventListener('DOMContentLoaded', () => {
  // InitCursor();
  InitFrontpage();
  InitReel();
  InitClips();
  InitAnchorClicks();
  InitPageAnimate();
});



// WEBPACK FOOTER //
// ./src/scripts/app.js